import React from "react";
import { Link } from "react-router-dom";
import Header from "../../component/common/Header";
import CONSTANT from "../../constant";

class PartFile extends React.Component<any, any> {
  componentDidMount() {
    document.title = "Part File";
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12 mb-3">
            <div className="card homedob p-4 mb-4">

              {/* TABS HEADER */}
              <div className="stickytabs">
                <div className="row">
                  <div className="col-md-12">
                    <div className="tabbedt round mb-4">
                      <ul>
                        <li>
                          <Link to={CONSTANT.component.userAddFile.url}>
                            Create New
                          </Link>
                        </li>
                        <li>
                          <Link
                            to={CONSTANT.component.partFile.url}
                            className="active"
                          >
                            Create Part File
                          </Link>
                        </li>

                        <li>
                          <Link to={CONSTANT.component.DraftList.url}>
                            Submit for Approval
                          </Link>
                        </li>

                        <li>
                          <Link to={CONSTANT.component.myFiles.url}>
                            My Files
                          </Link>
                        </li>

                        <li>
                          <Link to={CONSTANT.component.inbox.url}>
                            Inbox
                          </Link>
                        </li>

                        <li>
                          <Link to={CONSTANT.component.outbox.url}>
                            Outbox
                          </Link>
                        </li>

                        
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              {/* CONTENT */}
              <div className="text-center py-5">
                <div className="mb-4">
                  <i
                    className="fa fa-tools"
                    style={{ fontSize: "50px", color: "#0d6efd" }}
                  ></i>
                </div>

                <h3 className="mb-3">🚧 Part File Module</h3>

                <p className="text-muted" style={{ fontSize: "16px" }}>
                  We are currently working on this module.
                  <br />
                  It will be available soon.
                </p>

                <div className="mt-4">
                  <Link
                    to={CONSTANT.component.myFiles.url}
                    className="btn btn-primary"
                  >
                    Go Back to My Files
                  </Link>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default PartFile;
